import React, { Component } from 'react';
import { BarChart, Bar, Brush, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';

export default class Channels extends Component {
    static displayName = Channels.name;

    constructor(props) {
        super(props);
        this.state = { counts: [], siteID: props.id, siteName: props.name, userType: props.userType, step: "" };
    }

    componentDidMount() {
        this.state.siteID !== 0 && fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/month")
            .then(response => response.json())
            .then(data => {
                
                this.setState({ counts: data, step: "month" });
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.setState({ siteID: this.props.id, siteName: this.props.name, userType: this.props.userType }, () => {
                fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/month")
                    .then(response => response.json())
                    .then(data => {
                        this.setState({ counts: data, step: "month" });
                    });
            });
        }
    }

    handleClick = (data, index) => {
        var moment = require('moment');
        var date = moment(data.Name).format();
        date = date.substring(0, date.lastIndexOf("-"));
        if (this.state.step === "month") {
            fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/day/" + date)
                .then(response => response.json())
                .then(data => {
                    this.setState({ counts: data, step: "day" });
                });
        } else if (this.state.step === "day") {
            fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/15m/" + date)
                .then(response => response.json())
                .then(data => {
                    this.setState({ counts: data, step: "15m" });
                });
        }
        else if (this.state.step === "15m") {
            fetch('api/Site/GetSiteCount/' + this.state.siteID + "/step/month")
                .then(response => response.json())
                .then(data => {
                    this.setState({ counts: data, step: "month" });
                });
        }
    }

    render() {
        var moment = require('moment');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var data = [];
        var step = this.state.step;
        var siteName = this.state.siteName;
        var subtitle = this.state.userType === "1" ? " Pedestrian Traffic" : " Bike Traffic";
        var title = siteName + subtitle;
        this.state.counts.forEach(function (item) {
            var date = item.date;
            date = date.substring(0, date.indexOf("+"));
            var newDate = new Date(Date.parse(date));
            newDate.setHours(newDate.getHours() + 4);
            var dateString = "";
            if (step === "month") {
                dateString = monthNames[newDate.getMonth()] + ", " + newDate.getFullYear();
                data.push({
                    'Name': dateString,
                    'Count': item.counts
                });
            } else if (step === "day") {
                dateString = monthNames[newDate.getMonth()] + " " + newDate.getDate() + ", " + newDate.getFullYear();
                data.push({
                    'Name': dateString,
                    'Count': item.counts
                });
                title = siteName + subtitle + " - " + moment(newDate).format("MMM, YYYY");
            } else if (step === "15m") {
                dateString = moment(newDate).format("hh:mm a");
                data.push({
                    'Name': dateString,
                    'Count': item.counts
                });
                title = siteName + subtitle + " - " + moment(newDate).format("MMM DD, YYYY");
            }
        });
        var displayData = (
            <div style={{ textAlign: 'center' }}>
                <h5 style={{ fontWeight: 400, margin: '0 auto' }}>{title}</h5>
                <div style={{ width: '100%', height: 300 }}>
                    <ResponsiveContainer>
                        <BarChart
                            width={725}
                            height={300}
                            data={data}
                            margin={{
                                top: 5, right: 30, left: 20, bottom: 5
                            }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="Name" />
                            <YAxis />
                        <Tooltip />
                            <Brush dataKey="Name" height={30} stroke="#7d83ff" />
                            <Bar dataKey="Count" fill={this.state.userType === "1" ? "rgba(125,146,240, .7)" : "rgba(222,26,26, .7)"} onClick={this.handleClick} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        );
        return this.state.counts.length > 0 && displayData;
    }
}


// WEBPACK FOOTER //
// ./src/components/Channels.js